import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Button } from 'reactstrap';
import moment from 'moment';

import actions from './actions';

class ListaConsumo extends Component {
  componentDidMount () {
    this.props.actions.onLoadConsumoAgua();
  }
  render() {
    const { value: { result, fetching }, actions } = this.props;

    return (
      <Table striped hover responsive size="sm">
        <thead>
          <tr>
            <th colSpan="3">Água</th>
            <th colSpan="2" className="text-right"><Button color="link" size="sm" onClick={actions.onLoadConsumoAguaExterno}><span className={"fa fa-sync" + (1 === fetching?" fa-spin":"")} /></Button></th>
          </tr>
          <tr>
            <th className="d-none d-sm-table-cell">Unidade</th>
            <th>Compet.</th>
            <th className="text-right">Leitura (m³)</th>
            <th className="text-right">Consumo (m³)</th>
            <th className="text-right">Valor (R$)</th>
          </tr>
        </thead>
        <tbody>
          {result.map((v, i) => (
            <tr key={i}>
              <td className="d-none d-sm-table-cell">{v.unidade}</td>
              <td>{moment(v.competencia).format('MM/YYYY')}</td>
              <td className="text-right">{v.leitura.toLocaleString(undefined, { minimumFractionDigits:4, maximumFractionDigits:4 })}</td>
              <td className="text-right">{v.consumo.toLocaleString(undefined, { minimumFractionDigits:4, maximumFractionDigits:4 })}</td>
              <td className="text-right">{v.valor.toLocaleString(undefined, { minimumFractionDigits:2, maximumFractionDigits:2 })}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
}

let mapStateToProps = ({ consumo: { agua } }) => ({
  value: agua
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaConsumo);



// WEBPACK FOOTER //
// ./src/modules/consumo/ListaConsumoAgua.js